import React, {
  memo,
  useCallback,
  useMemo,
  useRef,
  useEffect,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Form, { FormConsumer } from '@active/react-ui/Form';
import FormGroup from '@active/react-ui/FormGroup';
import FormField from '@active/react-ui/FormField';
import FormLabel from '@active/react-ui/FormLabel';
import Input from '@active/react-ui/Input';
import Grid from '@active/react-ui/Grid';
import GridItem from '@active/react-ui/GridItem';
import isEmpty from 'lodash/isEmpty';
import { withI18n } from '@active/react-utils/i18n/LocaleContext';
import Locale from '@active/react-utils/i18n/Locale';
import pubSubInstance from '../../../../../../../../shared/utils/pubSub';
import CurrencyInputFormField from '../CurrencyInputFormField';
import { updatePaymentsInfoUsedForPay } from '../../../paymentMethodsSlice';

const Check = ({ i18n, paymentMethodType }) => {
  const {
    entities: {
      envParams: {
        currencyCode,
      },
    },
    refundTotalAmount,
  } = useSelector(state => state.mainStateData);

  const {
    paymentMethodsConfig: {
      isSingleMode = true,
    } = {},
    widgetNameSpace,
  } = useSelector(state => state.propsData);

  const dispatch = useDispatch();
  const formRef = useRef(null);

  const isPrefillValue = useMemo(() => isSingleMode, [ isSingleMode ]);

  const initValues = useMemo(() => {
    if (isPrefillValue) {
      return { checkAmount: refundTotalAmount };
    }
    return {};
  }, [ refundTotalAmount, isPrefillValue ]);

  const checkNumberValidator = useCallback((value) => {
    const reg = /^\w{1,100}$/;
    if (!reg.test(value)) {
      return i18n('checkout.lib.components.payment.check.valid.checkNumber');
    }
    return '';
  }, [ i18n ]);

  const handleValidate = useCallback(() => {
    return new Promise((resolve) => {
      formRef.current.validateForm({ shouldTouchFields: true }).then((res) => {
        resolve(isEmpty(res));
      });
    });
  }, [ formRef ]);

  const handleCheckNumberBlur = useCallback((e) => {
    dispatch(updatePaymentsInfoUsedForPay({
      paymentInfoObj: {
        paymentMethodType,
        checkNumber: e.target.value,
      },
      findPaymentConfig: { paymentMethodType },
    }));
  }, [ dispatch, paymentMethodType ]);

  useEffect(() => {
    pubSubInstance.subscribe(`${widgetNameSpace}-payment-item-validate`, handleValidate);
    return () => {
      pubSubInstance.unsubscribe(`${widgetNameSpace}-payment-item-validate`, handleValidate);
    };
  }, [ handleValidate, widgetNameSpace ]);

  return <div className='multi-payment-check'>
    <Grid container={false} colGap={30} rowGap={20}>
      <GridItem span={12} spanMd={6} className='check-number-field' >
        <Form customizeLayout>
          <FormGroup name='checkNumber' required onBlur={handleCheckNumberBlur}>
            <FormLabel>
              <Locale id="checkout.lib.components.payment.check.checkNumber" />
            </FormLabel>
            <FormField
              maxLength="100"
              autoComplete="off"
              id="checkNumber"
              validate={checkNumberValidator}
              as={Input}/>
          </FormGroup>
          <FormConsumer>
            {
              ({
                form,
              }) => {
                formRef.current = form;
              }
            }
          </FormConsumer>
        </Form>
      </GridItem>
      <GridItem span={12} spanMd={6} className='check-item__amount'>
        <Form
          enableReinitialize
          initialValues={initValues}
          customizeLayout>
          <CurrencyInputFormField
            paymentMethodType={paymentMethodType}
            isPrefillValue={isPrefillValue}
            name='checkAmount'
            disabled={isPrefillValue}
            code={currencyCode}/>
        </Form>
      </GridItem>
    </Grid>
  </div>;
};

export default memo(withI18n(Check));
